<template>
  <div class="item-wrap w-100 d-f fd-c g m-b">
    <!-- Static label row + switch (same as Opt-out); not a collapsible dropdown -->
    <div class="toggle-wrapper w-100 d-f ai-c">
      <div class="flex-1 d-f fd-c min-w-0">
        <p class="m-0">{{ title }}</p>
        <p v-if="subtitle" class="mute font-small m-0">{{ subtitle }}</p>
      </div>
      <ToggleSwitch
        v-if="showCheckbox"
        :checked="checked"
        @on-change="toggleCheckbox"
      />
    </div>
    <div class="content-slot d-f fd-c g">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/misc/ToggleSwitch.vue";

export default {
  name: "SettingsLabelDropboxDropdown",
  components: {
    ToggleSwitch,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  methods: {
    toggleCheckbox(v) {
      this.$emit("on-change", v);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";

/* Allow title + optional subtitle without clipping (global .toggle-wrapper is fixed height) */
.toggle-wrapper {
  min-height: $btn-height;
  height: auto;
}

/* Match SettingsLabelProfile.vue description textarea */
.content-slot {
  ::v-deep .desc-field {
    position: relative;

    .char-count {
      position: absolute;
      right: $mg-desktop-md;
      bottom: calc(#{$mg-desktop-md} / 2);
      pointer-events: none;
    }
  }

  ::v-deep .desc-textarea-wrap .desc-textarea {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 140px;
    resize: vertical;
    min-height: 60px;
    padding-right: 2.5rem;
    padding-bottom: 1.5rem;
    -webkit-overflow-scrolling: touch;
    word-wrap: break-word;
  }
}
</style>
